import React, {useEffect} from 'react'
import Image from "next/image";
import bannerStyle from "../../../styles/sass/bannerinner.module.scss";
import { setHeaderSpace } from "../../../utils/CommonFunctions";

const BannerInner = ({ imageSrc, title, ribbonText= {}, actualPrice="", discountedPrice="", offerTagTxt= {} }) => {
    
    /* for set header */
    useEffect(() => {
        setHeaderSpace();
    }, []);

    return ( 
        <>  
        <div id="setSpacer" className="setBanner">
            <div className="bannerInner">
                <section className={`mc_container_fluid ${bannerStyle["banner-top"]}`}>
                    <div className="mc_row_new">
                        <div className={`${bannerStyle["image-cb"]}`}>
                            <Image
                                src={imageSrc?.src}
                                objectFit="cover"
                                layout="fill"
                                priority={true}
                                alt={title}
                            />
                                <div className={`${bannerStyle["banner-text-cb"]} c-text-container`}>
                                    {actualPrice && (
                                    <div className={` heading-title ${bannerStyle["banner-price"]}`}>
                                        {actualPrice.length && (
                                            <i className={`${bannerStyle["banner-text-strike"]}`}>{actualPrice}</i> 
                                        )}
                                    <i className={`${bannerStyle["banner-text-block"]}`}>{discountedPrice}</i></div>
                                )}   
                                
                                {title && (
                                    <div className={`${bannerStyle["banner-inner-text-cb"]}`}> 
                                        <div className="heading-title banner-heading-title white-color">
                                            <h1>{title}</h1>
                                            </div>
                                    </div>
                                )}
                            </div>
                                        
                            {typeof ribbonText !== null && typeof ribbonText !== "undefined" && Object.keys(ribbonText).length && (
                                <div className='ribbonContainer'>
                                    <div className="ribbon">
                                        {ribbonText.line_1} {ribbonText.line_2}
                                        <i></i>
                                        <i></i>
                                        <i></i>
                                        <i></i>
                                    </div>
                                </div> 
                            )}

                                {typeof offerTagTxt !== null && typeof offerTagTxt !== "undefined" && Object.keys(offerTagTxt).length && (
                                    <div className={`${bannerStyle["banner-offer-cb"]} c-text-container`}>
                                        <div className={`${bannerStyle["banner-offer-text"]}`}>
                                            <p>{offerTagTxt?.name}</p>
                                            <h6>{offerTagTxt?.discount_percent}</h6>
                                            <p>Discount</p>
                                        </div>
                                    </div>
                                )}


                        </div>
                    </div>
                </section>
            </div>
        </div>
        </>
     );
}
 
export default BannerInner;
